'use client';

import { Section, ThreeStack } from '@/ui';
import Banner from './Banner';
import Currency from './Currency';
import Weather from './Weather';

export function ExternalInfo() {
  return (
    <Section>
      <ThreeStack flexible className="place-items-center gap-20">
        <Weather />
        <Banner />
        <Currency />
      </ThreeStack>
    </Section>
  );
}
